import React from 'react';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import { MDXProvider } from '@mdx-js/react';

import YamlTable from '../YamlTable';

import CE from './images/certification-logo/CE.svg';
import FCC from './images/certification-logo/FCC.svg';
import IC from './images/certification-logo/IC.svg';
import MIC from './images/certification-logo/MIC.svg';
import RoHS from './images/certification-logo/RoHS.svg';
import UKCA from './images/certification-logo/UKCA.svg';
import RCM from './images/certification-logo/RCM.svg';
import KC from './images/certification-logo/KC.svg';

import './ProductTechSpec.scss';

interface CertificationIconsProps {
  certifications: Array<any>;
}

export function CertificationIcons({ certifications }: CertificationIconsProps) {
  if (!certifications) {
    return null;
  }

  const logos = {
    CE,
    FCC,
    IC,
    MIC,
    RoHS,
    UKCA,
    RCM,
    KC,
  };

  return (
    <>
      <div className="product-text-spec__certification-logo">
        {certifications.map((icon) => logos[icon] && <img src={logos[icon]} key={icon} alt="certification" />)}
      </div>
      <a href="/certifications" target="_blank" rel="noopener noreferrer" className={'product-text-spec__learn-more'}>
        {'Learn More'}
      </a>
    </>
  );
}

interface ProductTechSpecProps {
  info: {
    body: string;
  };
  techspecs: {
    fields: {
      content: string;
    };
  };
  certifications: Array<any>;
}

export default function ProductTechSpec({ info, techspecs, certifications }: ProductTechSpecProps): React.ReactElement {
  return (
    <div className="product-text-spec">
      <div className="product-text-spec__content">
        {info?.body && (
          <MDXProvider
            components={{
              CertificationIcons: (props) => <CertificationIcons {...props} {...(certifications ? { certifications } : {})} />,
            }}
          >
            <MDXRenderer>{info?.body}</MDXRenderer>
          </MDXProvider>
        )}
      </div>
      <div>{techspecs && <YamlTable>{techspecs.fields?.content}</YamlTable>}</div>
    </div>
  );
}
